import { render, staticRenderFns } from "./moneyNoTextLayer.vue?vue&type=template&id=1226cdee&scoped=true&"
import script from "./moneyNoTextLayer.vue?vue&type=script&lang=js&"
export * from "./moneyNoTextLayer.vue?vue&type=script&lang=js&"
import style0 from "./moneyNoTextLayer.vue?vue&type=style&index=0&id=1226cdee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1226cdee",
  null
  
)

export default component.exports